import React, {Fragment, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {ErrorDocForm} from './ErrorDocForm'
import {ReportLink} from "./ReportLink";

interface ErrorDocDialogProps {
    documentId: string
    documentVersion: number;
}

export const ErrorDocDialog: React.FC<ErrorDocDialogProps> = ({documentId, documentVersion}) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const openDialog = () => setIsVisible(true);
    const closeDialog = () => setIsVisible(false);

    return (
            <>
                <ReportLink handleClick={openDialog}/>

                <Transition.Root show={isVisible} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={closeDialog}>
                        <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                                <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel
                                            className="relative transform overflow-hidden shadow-xl transition-all my-8 w-full max-w-lg">
                                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                            <div className="mt-3 text-center sm:text-left">
                                                <Dialog.Title as="h3"
                                                              className="text-lg leading-6">
                                                    Сообщить об ошибке в документе
                                                </Dialog.Title>

                                                <div className="mt-4">
                                                    <ErrorDocForm
                                                            documentId={documentId}
                                                            documentVersion={documentVersion}
                                                            successfulSubmitCallback={closeDialog}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </>
    )
}
